import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import Quality from './Quality';
import Validation from '../../../components/Validation';
import Issues from '../../../components/Issues';
import Documentation from '../../../components/Documentation';
import { PageHeader } from '../../../components/common';

function QualityCompliance() {
  const location = useLocation();
  const navigate = useNavigate();

  // Determine active tab from current path
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/documentation')) return 'documentation';
    if (path.includes('/validation')) return 'validation';
    if (path.includes('/issues')) return 'issues';
    if (path.includes('/quality')) return 'quality';
    return 'quality';
  };

  // Get current tab label for breadcrumbs
  const getCurrentTabLabel = () => {
    const activeTab = getActiveTab();
    const tab = tabItems.find(item => item.key === activeTab);
    return tab ? tab.label : 'Quality & Compliance';
  };

  // Tab items
  const tabItems = [
    {
      key: 'quality',
      label: 'Quality',
    },
    {
      key: 'documentation',
      label: 'Documentation',
    },
    {
      key: 'validation',
      label: 'Validation',
    },
    {
      key: 'issues',
      label: 'Issues',
    },
  ];

  const handleTabChange = (key) => {
    navigate(`/quality-compliance/${key}`);
  };

  return (
    <>
      <PageHeader
        title="Quality & Compliance"
        breadcrumbs={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Quality & Compliance', path: '/quality-compliance' },
          { label: getCurrentTabLabel() }
        ]}
      />

      <Tabs
        activeKey={getActiveTab()}
        items={tabItems}
        onChange={handleTabChange}
        style={{ marginBottom: '24px' }}
      />

      <Routes>
        <Route index element={<Navigate replace to="quality" />} />
        <Route path="quality" element={<Quality />} />
        <Route path="documentation" element={<Documentation />} />
        <Route path="validation" element={<Validation />} />
        <Route path="issues" element={<Issues />} />
      </Routes>
    </>
  );
}

export default QualityCompliance;
